import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import {environment} from '../../../containers/environment';

const Ava = `${process.env.PUBLIC_URL}/img/capacete.png`;

class TopbarProfile extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  logout = () => {
    useBasicAuth.logout();
  }

  render() {
    const { t } = this.props;
    const { collapse } = this.state;

    // MCCOSTA: TopbarProfile

    return (
      <div className="topbar__profile">
        <button className="topbar__avatar" type="button" onClick={this.toggle}>
          <img
            className="topbar__avatar-img"
            src={Ava}
            alt="avatar"
          />
          <p className="topbar__avatar-name">
            { environment.getUserName() }
          </p>
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            <TopbarMenuLink
              title={t("topbar.profile")}
              icon="user"
              path="/account/profile"
              onClick={this.toggle}
            />
            {/* <TopbarMenuLink
              title="Calendar"
              icon="calendar-full"
              path="/default_pages/calendar"
              onClick={this.toggle}
            /> */}
            {/* <TopbarMenuLink
              title="Tasks"
              icon="list"
              path="/todo"
              onClick={this.toggle}
            />
            <TopbarMenuLink
              title="Inbox"
              icon="inbox"
              path="/mail"
              onClick={this.toggle}
            /> */}
            <div className="topbar__menu-divider" />
            {/* <TopbarMenuLink
              title="Account Settings"
              icon="cog"
              path="/account/profile"
              onClick={this.toggle}
            /> */}
            {/* <TopbarMenuLink
              title="Lock Screen"
              icon="lock"
              path="/lock_screen"
              onClick={this.toggle}
            /> */}
            <TopbarMenuLink
              title={t("topbar.log_out")}
              icon="exit"
              path="/log_in"
              onClick={this.logout}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

export default withTranslation('common')(TopbarProfile);
